/**
 * @fileoverview Agent definition for plot-type-suggester-v2.
 *
 * Suggests suitable plot types based on a story blurb.
 *
 * @category narrative.story.metadata
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-type-suggester-v2',
  kind: 'primitive',
  name: 'Plot Type Suggester',
  description: 'Suggests suitable plot types based on a story blurb.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2025-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.story.metadata',
    usedBy: ['use-story-suggestions.ts', 'story-plot-type-card.tsx'],
    relatedAgents: ['pov-suggester-v2'],
  },
};
